/* eslint-disable no-prototype-builtins */
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';

export const filterActiveRoles = (response) => {
  return response.filter((role) => {
    return role.status === 'active';
  });
};

export const buildGetAccountRolesRequest = (accountId, name) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/roles?limit=200${
    name ? `&filter[name]=${name}` : ''
  }`;
